import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-statements',
    templateUrl: './statements.component.html',
    styleUrls: ['./statements.component.scss'],
    standalone: false
})
export class StatementsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
